import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_MENU_GROUP_LABEL = 'API';
const API_DOCUMENTATION_MENU_ITEM_LABEL = 'Documentation';

export const getNavigationConfig = createAsyncThunk('getNavigationConfig', async () => {
    const response = await axios.get(`/top-menu`);
    const data = response?.data;
    const apiUrl = process.env.REACT_APP_API;
    if (data && Array.isArray(data.autoformsMenu) && apiUrl) {
        for (const menuGroup of data.autoformsMenu) {
            if (
                menuGroup &&
                Array.isArray(menuGroup.items) &&
                menuGroup.label.toLowerCase() === API_MENU_GROUP_LABEL.toLowerCase()
            ) {
                const documentationItem = menuGroup.items.find(
                    (item) => item.label.toLowerCase() === API_DOCUMENTATION_MENU_ITEM_LABEL.toLowerCase()
                );
                if (documentationItem) {
                    documentationItem.url = `${apiUrl}/swagger/index.html`;
                    break;
                }
            }
        }
    }
    return data;
});
